import React, {Component} from 'react';
import {Page} from 'framework7-react';

import './DownloadAppPopup.css';
import Popup from "../popup/Popup";
import PrimaryButton from "../../primaryButton/PrimaryButton";
import mainAPI from "../../../api/MainAPI";
import copyToClipboard from "../../../utils/copyToClipboard";
import Label from "../../label/Label";

export default class DownloadAppPopup extends Component {
	constructor(props) {
		super(props);
		this.videoRef = React.createRef();
	}

	async componentDidMount() {
		this.shortTermToken = mainAPI.short_term_token.create();

		// Additional handling for Cordova video playback
		if (this.videoRef.current) {
			const video = this.videoRef.current;
			
			// Prevent fullscreen on play
			video.addEventListener('webkitbeginfullscreen', (e) => {
				e.preventDefault();
				video.webkitExitFullscreen();
			});
			
			// Handle presentation mode changes
			video.addEventListener('webkitpresentationmodechanged', (e) => {
				if (video.webkitPresentationMode === 'fullscreen') {
					video.webkitSetPresentationMode('inline');
				}
			});
			
			// Set additional properties for inline playback
			video.setAttribute('webkit-playsinline', 'true');
			video.setAttribute('playsinline', 'true');
			video.setAttribute('x-webkit-airplay', 'allow');
			
			// Force inline mode
			if (video.webkitSetPresentationMode) {
				video.webkitSetPresentationMode('inline');
			}
		}
	}

	copyTokenAndDownload = async () => {
		await this.copyToken();
		await setTimeoutAsync(50);
		this.openAppStore();
		this.shortTermToken = mainAPI.short_term_token.create(); // reset token
	}

	copyToken = async () => {
		try {
			const shortTermToken = await this.shortTermToken;
			await copyToClipboard(shortTermToken.id, false);
		} catch (e) {
			console.log('Error during download process:', e);
			// Continue with download even if clipboard fails
		}

	}
	openAppStore = () => {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		const isAndroid = /android/i.test(userAgent);
		
		let downloadUrl = 'https://apps.apple.com/app/id1095064884'; // Default to iOS
		if (isAndroid) {
			downloadUrl = 'https://play.google.com/store/apps/details?id=com.logrx.main';
		}
		
		// Use a more reliable navigation method
		window.open(downloadUrl, '_blank');
	};

	getButtonText = () => {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
		const isAndroid = /android/i.test(userAgent);
		
		if (isAndroid) {
			return 'Download on Google Play';
		} else if (isIOS) {
			return 'Download on the App Store';
		} else {
			return 'Download on the App Store'; // Default fallback
		}
	};

	isMobileDevice = () => {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
		const isAndroid = /android/i.test(userAgent);
		return isIOS || isAndroid;
	};

	render() {
		const isMobile = this.isMobileDevice();
		
		return (
			<Popup opened={this.props.opened}
						 className="g-download-app-popup">
				<Page>
					<Label className='center top-label' large dark bold>Now download the app</Label>
					<div className="iphone-video screenshot center">
						<img alt="phone-background" className="iphone-no-background"
								 src="https://logrx.com/assets/optimized/Iphone-outline-video.webp?v=65f179bd11"/>
						<video 
							autoPlay={true} 
							loop={true} 
							muted={true} 
							playsInline={true} 
							webkit-playsinline={true}
							x-webkit-airplay="allow"
							controls={false}
							preload="auto"
							className="screenshot-video" 
							ref={this.videoRef}>
							<source src="https://logrx.com/assets/optimized/app-demo.mp4" type="video/mp4"/>
						</video>
					</div>

					{isMobile ? (
						<PrimaryButton className={'center'} onClick={this.copyTokenAndDownload}>{this.getButtonText()}</PrimaryButton>
					) : (
						<Label className='center' dark>Please download the LogRx app on your phone</Label>
					)}
				</Page>
			</Popup>
		)
	}
}
const setTimeoutAsync = (ms) => {
	return new Promise(resolve => setTimeout(resolve, ms));
};
